import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import {Component, Inject} from "@angular/core";

@Component({
  selector: 'modal-email-report',
  templateUrl: 'modal-email-report.component.html',
})
export class ModalEmailReportComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalEmailReportComponent>,
    @Inject(MAT_DIALOG_DATA) public email: string,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
